import DomainEntity from '@/models/DomainEntity'

export default class StateInvoices extends DomainEntity {
  static get collectionName() {
    return 'stateinvoices/'
  }

  static get parentKey() {
    return 'state'
  }

  static defaults() {
    return {
      items: {},
    }
  }
}
